function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 63",
  d: "M333.904 171.405l-28.257 1.908a141.936 141.936 0 00-132.158 132.158l-1.9 28.315a2.981 2.981 0 01-5.961 0l-1.909-28.315a141.935 141.935 0 00-132.16-132.158l-28.255-1.908a2.8 2.8 0 010-5.6l28.255-1.908A141.935 141.935 0 00163.715 31.736l1.909-28.256a2.981 2.981 0 115.961 0l1.9 28.256A141.937 141.937 0 00305.71 163.894l28.253 1.908a2.8 2.8 0 11-.06 5.6z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgShineOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337.236,
    height: 337.266,
    viewBox: "0 0 337.236 337.266"
  }, props), _ref);
}

export default SvgShineOutlinedinline;